import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
 /* Override antd's global.less reset margins */
  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 0;
  }

  p {
    margin-bottom: 0;
  }

  .ant-notification {
    z-index: var(--zindex-layer-1111);
   }
    .ant-notification-notice-message {
        margin-bottom: 0px;
    }
`;
